export const CREATOR_REFERRAL_LINK = 'https://grow.grin.co/partner-as-creator/';
